if ('serviceWorker' in navigator) {
    const onLoad = () => {
        navigator.serviceWorker.register('/sw.js')
        window.removeEventListener('load', onLoad)
    }
    window.addEventListener('load', onLoad)
}
